// extracted by mini-css-extract-plugin
export default {"uploadIconContainer":"ImportFile_uploadIconContainer__kCl+Z"};